export const SERVER_CONFIG = {
  IP: 'localhost',
  PORT: '5173',
  get BASE_URL() {
    return `http://${this.IP}:${this.PORT}`;
  }
};

export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;
export const GENERATE_AD_URL = import.meta.env.VITE_GENERAR_ANUNCIO_URL;
// V3 — usado solo por la generación de la Interfaz V2 (modo Imagen con
// modelo + plantillas). El resto de la app sigue con V2.
export const GENERATE_AD_V3_URL =
  import.meta.env.VITE_GENERAR_ANUNCIO_V3_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/generar_anuncio_v3';
export const GENERATE_VIDEO_CREATOR_URL =
  import.meta.env.VITE_GENERATE_VIDEO_CREATOR_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/generar_video_creator';
// Webhook del modo "Video con influencer" (UGC) de la Interfaz V2. Mismo
// payload/flujo que el Director de Estudio pero con su propio workflow en n8n.
export const GENERATE_VIDEO_INFLUENCER_URL =
  import.meta.env.VITE_GENERATE_VIDEO_INFLUENCER_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/video_influencer';
export const GENERATE_AUDIO_CREATOR_URL =
  import.meta.env.VITE_GENERATE_AUDIO_CREATOR_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/generar_audio_creator';
// Endpoints para traducción de video con lip-sync (HeyGen Video Translate v3).
// Async: START dispara el job y devuelve un jobId; STATUS se polea cada N
// segundos hasta que el video traducido esté listo.
export const TRANSLATE_VIDEO_START_URL =
  import.meta.env.VITE_TRANSLATE_VIDEO_START_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/traducir_video_creator_start';
export const TRANSLATE_VIDEO_STATUS_URL =
  import.meta.env.VITE_TRANSLATE_VIDEO_STATUS_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/traducir_video_creator_status';
// Endpoints para borrado de objetos en video (Bria video-erase-object via
// Replicate). Async: START dispara el job (n8n corta el clip, llama a Bria por
// chunk, recose y sube el resultado) y devuelve un jobId; STATUS se polea hasta
// que el video borrado esté listo.
export const BRIA_ERASE_START_URL =
  import.meta.env.VITE_BRIA_ERASE_START_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/bria_erase_start';
export const BRIA_ERASE_STATUS_URL =
  import.meta.env.VITE_BRIA_ERASE_STATUS_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/bria_erase_status';
// SAM2 para el pincel inteligente. `sam2_mask`: frame + marcas → máscara del
// frame (preview, ~síncrono/poll corto). `sam2_propagate`: clip + marcas →
// mask-video propagado a todos los frames (async, encadena con bria_erase).
export const SAM2_MASK_URL =
  import.meta.env.VITE_SAM2_MASK_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/sam2_mask';
export const SAM2_ERASE_START_URL =
  import.meta.env.VITE_SAM2_ERASE_START_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/sam2_erase_start';
export const SAM2_ERASE_STATUS_URL =
  import.meta.env.VITE_SAM2_ERASE_STATUS_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/sam2_erase_status';
// Poses personalizadas (Interfaz V2): el cliente sube una pose → este webhook
// la copia sobre el muñeco default, guarda en `poses_personalizadas` y devuelve
// la pose. Patrón clonado de `procesar_modelo_propio`.
export const PROCESAR_POSE_URL =
  import.meta.env.VITE_PROCESAR_POSE_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/procesar_pose_subida';

export const GENERATE_AUTH_TOKEN = import.meta.env.VITE_GENERATE_AUTH_TOKEN;

// ─── ConfigCat (feature flags / kill-switch de mantenimiento) ──────────────
// El SDK key es PÚBLICO (read-only, seguro para el front, igual que el anon key
// de Supabase). El flag de mantenimiento vive ACÁ y NO en Supabase a propósito:
// la pantalla de mantenimiento es justo lo que querés mostrar cuando Supabase se
// cae, así que el flag debe estar en infra independiente (ConfigCat entrega la
// config por CDN global). Ver ADR-135.
export const CONFIGCAT_SDK_KEY =
  import.meta.env.VITE_CONFIGCAT_SDK_KEY ||
  'configcat-sdk-1/cdveCGkKxEaKQxOGq_FrcA/9vvRoFkQDkqIct65MJelKA';
// Nombre EXACTO del flag booleano creado en el panel de ConfigCat (verificado
// contra el CDN: `maintenanceMode`). Si lo matcheás mal, el SDK devuelve el
// default `false` y el mantenimiento nunca se activa (falla en silencio). Si
// renombrás el flag en el panel, actualizá VITE_CONFIGCAT_MAINTENANCE_KEY.
export const CONFIGCAT_MAINTENANCE_KEY =
  import.meta.env.VITE_CONFIGCAT_MAINTENANCE_KEY || 'maintenanceMode';

// ─── Rebill (suscripciones, Argentina) — checkout embebido ─────────────────
// Gateway de pagos para clientes AR (reemplaza a MercadoPago). Rebill expone un
// web component (`<rebill-checkout>`) que crea el checkout de suscripción desde
// el FRONT usando solo el PUBLIC KEY (seguro para el cliente) + un `plan-id` del
// panel. El backend solo procesa los webhooks (activar plan, cancelar la sub
// vieja). Ver docs/superpowers/specs/2026-07-02-rebill-checkout-integration-design.md
//
// Public key de la organización (seguro para el front).
export const REBILL_PUBLIC_KEY = import.meta.env.VITE_REBILL_PUBLIC_KEY || '';
// Entorno del SDK de Rebill: 'development' | 'staging' | 'production'. El
// carácter sandbox/live lo define el public key; esto solo elige el host de la
// API del SDK. Default: 'production'.
export const REBILL_ENV = (import.meta.env.VITE_REBILL_ENV || 'production') as
  | 'development'
  | 'staging'
  | 'production';
// Mapa plan de Atlas → plan-id (`pln_...`) de Rebill. Cada plan de Atlas necesita
// un plan creado en el panel de Rebill, AL MISMO PRECIO que Atlas (para que el
// precio que muestra la pantalla coincida con el cobro). Completar los env
// `VITE_REBILL_PLAN_*` cuando existan los planes. Si un plan no está mapeado,
// `RebillCardPayment` muestra un error claro en vez de romper.
export const REBILL_PLAN_IDS: Record<string, string> = {
  emprendimiento: import.meta.env.VITE_REBILL_PLAN_EMPRENDIMIENTO || '',
  negocio: import.meta.env.VITE_REBILL_PLAN_NEGOCIO || '',
  enterprise1: import.meta.env.VITE_REBILL_PLAN_ENTERPRISE1 || '',
  enterprise2: import.meta.env.VITE_REBILL_PLAN_ENTERPRISE2 || '',
  enterprise3: import.meta.env.VITE_REBILL_PLAN_ENTERPRISE3 || '',
};
// Base del server de pagos de Atlas. TODO request al payment server debe ir con el
// auth de Atlas (Bearer `GENERATE_AUTH_TOKEN`) → usar `paymentServerFetch`
// (lib/paymentServer.ts), que lo inyecta solo.
export const PAYMENT_SERVER_URL =
  import.meta.env.VITE_PAYMENT_SERVER_URL ||
  'https://atlas-payment-server.onrender.com';
// Endpoint del server de pagos para el cambio de plan one-click de clientes que YA
// están en Rebill (cobra la tarjeta guardada server-side, sin pedir tarjeta ni OTP).
// POST { user_id, plan } → { ok:true, subscriptionId } | { ok:false, error }.
export const REBILL_CHANGE_PLAN_URL =
  import.meta.env.VITE_REBILL_CHANGE_PLAN_URL ||
  `${PAYMENT_SERVER_URL}/rebill/change-plan`;
// Gestión de suscripción en el payment server. Los 4 endpoints son
// MULTIPLATAFORMA (el server resuelve MP vs Rebill solo; no ramificar en el front).
// POST /cancel { user_id, motivo?, detalle? } → { ok:true, scheduledFor }.
export const PAYMENT_CANCEL_URL =
  import.meta.env.VITE_PAYMENT_CANCEL_URL || `${PAYMENT_SERVER_URL}/cancel`;
// POST /reactivate { user_id } → { ok:true, nextChargeDate|null }. Deshace una
// cancelación programada vigente (no cobra nada ahora, el ciclo ya estaba pago).
export const PAYMENT_REACTIVATE_URL =
  import.meta.env.VITE_PAYMENT_REACTIVATE_URL ||
  `${PAYMENT_SERVER_URL}/reactivate`;
// POST /pause { user_id, resume_at? } → { ok:true, resumeAt|null }.
export const PAYMENT_PAUSE_URL =
  import.meta.env.VITE_PAYMENT_PAUSE_URL || `${PAYMENT_SERVER_URL}/pause`;
// POST /resume { user_id } → { ok:true }. Rebill cobra al reanudar; MP cobra en
// su próxima fecha de facturación.
export const PAYMENT_RESUME_URL =
  import.meta.env.VITE_PAYMENT_RESUME_URL || `${PAYMENT_SERVER_URL}/resume`;